var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;
	var btnText = lang.template('领取');

__p+='\n<div class="tasks">\n	<ul class="reward">\n		';

			_.each(taskActInfo,function(item,index){
			var toReward = 0;
			toReward = item.rewardList.toreward || 0;
			var rewarded = item.rewardList.rewarded || 0;
			
			console.log(toReward);
		
__p+='\n		<li>\n			<div class="toreward">'+
((__t=(lang.template('可领取限定礼物个数:{count}',{count:toReward})))==null?'':__t)+
'</div>\n			<div class="reward-btn ';
if(toReward <= 0){
__p+=' disable';
}
__p+='" node-id="reward-task" data-acid="'+
((__t=(item.activityId))==null?'':__t)+
'" data-toreward="'+
((__t=(toReward))==null?'':__t)+
'">'+
((__t=(btnText))==null?'':__t)+
'</div>\n		</li>\n		';


		})
		
__p+='\n	</ul>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/component/task/task.tmpl
// module id = 26
// module chunks = 0 1